import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button } from 'react-bootstrap'

const ModalDescripcionPlan = ({ tienda }) => {
  const [show, setShow] = useState(false)
  const handleModal = () => {
    setShow(!show)
  }

  return (
    <div>
      <Button
        data-target="#descripcionPlan"
        data-toggle="modal"
        variant="datos-perfil"
        onClick={handleModal}
      >
        <span className="float-left">Descripción del Plan</span>
        <span className="float-right">Haga click para ver la Descripción</span>
      </Button>

      {/* Modal */}
      {show && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
          onClick={handleModal}
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Verifique los beneficios del Plan</h5>
                <button type="button" className="close" onClick={handleModal}>
                  <span>x</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{tienda.descripcion}</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={handleModal}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <li className="btn-datos-perfil">
        <span className="float-left">Banner</span>&nbsp;
        <span className="float-right">
          <i
            className={`${
              tienda.usaBanner
                ? ' fa fa-check-circle f-ebm-green '
                : ' fa fa-times f-red  '
            }`}
            aria-hidden="true"
          />
        </span>
      </li>
    </div>
  )
}

ModalDescripcionPlan.propTypes = {
  tienda: PropTypes.shape({
    descripcion: PropTypes.string,
    usaBanner: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  }).isRequired
}

export default ModalDescripcionPlan
